import { connect } from 'react-redux';
import { TWSessionInfo } from '.';
import { getUserSessionBookings as getUserSessionBookingsAction } from '../../../state/actions';

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var existingBooking = ownProps.session ? state.booking.sessionBookings[ownProps.session.id] : null;
  return {
    existingBooking: existingBooking,
    currentUser: state.auth.users.current
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getUserSessionBookings: function getUserSessionBookings(sessionId) {
      return dispatch(getUserSessionBookingsAction(sessionId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TWSessionInfo);